import { Nullable } from "@/general/custom-types/CustomTypes";
import { RegisterFormModel } from "@/context/model/model/RegisterFormModel";

export class ModelFormModel {
  id?: Nullable<number>;
  manufacturer?: Nullable<string>;
  model?: Nullable<string>;
  registers?: Nullable<RegisterFormModel[]>;

  constructor(
    id?: Nullable<number>,
    manufacturer?: Nullable<string>,
    model?: Nullable<string>,
    registers: Nullable<RegisterFormModel[]> = []
  ) {
    this.id = id;
    this.manufacturer = manufacturer;
    this.model = model;
    this.registers = registers;
  }
}
